import Loader from '@/components/Loader'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

type ProcessingOverlayProps = {
  className?: string
  animate?: boolean
}

export default function ProcessingOverlay({
  className = '',
  animate = false,
}: ProcessingOverlayProps) {
  const t = useTranslations()

  return (
    <div
      className={cn(
        'grid size-full place-items-center rounded-lg',
        animate ? 'animate-pulse' : '',
        className,
      )}
      style={{
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)',
      }}
    >
      <div className="flex flex-col items-center gap-2">
        <Loader variant="process" size="sm" />
        <p className="body-2">{t('profile-page.upload-processing')}</p>
        <p className="caption">{t('profile-page.upload-processing-hint')}</p>
      </div>
    </div>
  )
}
